import { render, staticRenderFns } from "./resend.vue?vue&type=template&id=80bf2e36&scoped=true"
import script from "./resend.vue?vue&type=script&lang=js"
export * from "./resend.vue?vue&type=script&lang=js"
import style0 from "./resend.vue?vue&type=style&index=0&id=80bf2e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf2e36",
  null
  
)

export default component.exports